<template>
  <div>

    <div class="re-section re-section--primary">
      <div class="re-section__head">
        <div class="re-section__icon"><feather-icon icon="UserIcon" size="20"/></div>
        <div class="re-section__titles">
          <div class="re-section__title">{{ msg('Owner / Contact') }}</div>
          <div class="re-section__sub">{{ msg('Contact person and owner details') }}</div>
        </div>
      </div>
      <div class="re-section__body">
    <b-row class="mt-1">
      <!-- Contact Image -->
      <b-col cols="1">
        <b-img
            :src="realEstate.contactPerson.imageUrl"
            height="60"
            width="60"
            alt=""
            class="mr-1"
        />
      </b-col>

      <!-- ID -->
      <b-col cols="2">
        <b-form-group :label="msg('Id')" label-for="realEstate-buy-price">
          <b-form-input
              id="realEstate-buy-price"
              readonly
              v-model="realEstate.contactPerson.personNum"
              @change="onValueUpdated"
          />
        </b-form-group>
      </b-col>

      <!-- Salutation -->
      <b-col cols="2">
        <b-form-group :label="msg('Salutation')" label-for="realEstate-type">
          <v-select
              @option:selected="onValueUpdated"
              :dir="isRTL ? 'rtl' : 'ltr'"
              v-model="realEstate.contactPerson.salutation"
              :options="[
              { value: 'm', label: msg('Mr') },
              { value: 'w', label: msg('Mrs') }
            ]"
              label="label"
              :reduce="status => status.value"
              class="w-100"
          />
        </b-form-group>
      </b-col>

      <!-- Firstname -->
      <b-col cols="4">
        <b-form-group :label="msg('firstname')" label-for="realEstate-buy-price">
          <b-form-input
              id="realEstate-buy-price"
              v-model="realEstate.contactPerson.firstname"
              @change="onValueUpdated"
          />
        </b-form-group>
      </b-col>

      <!-- Lastname -->
      <b-col cols="3">
        <b-form-group :label="msg('lastname')" label-for="realEstate-buy-price">
          <b-form-input
              id="realEstate-buy-price"
              v-model="realEstate.contactPerson.lastname"
              @change="onValueUpdated"
          />
        </b-form-group>
      </b-col>

      <!-- Email -->
      <b-col cols="3">
        <b-form-group :label="msg('email')" label-for="realEstate-buy-price">
          <b-form-input
              id="realEstate-buy-price"
              v-model="realEstate.contactPerson.email"
              @change="onValueUpdated"
          />
        </b-form-group>
      </b-col>

      <!-- Mobile -->
      <b-col cols="3">
        <b-form-group :label="msg('mobile')" label-for="realEstate-buy-price">
          <b-form-input
              id="realEstate-buy-price"
              v-model="realEstate.contactPerson.mobile"
              @change="onValueUpdated"
          />
        </b-form-group>
      </b-col>

      <!-- Phone -->
      <b-col cols="3">
        <b-form-group :label="msg('phone')" label-for="realEstate-buy-price">
          <b-form-input
              id="realEstate-buy-price"
              v-model="realEstate.contactPerson.phone"
              @change="onValueUpdated"
          />
        </b-form-group>
      </b-col>

      <!-- Fax -->
      <b-col cols="3">
        <b-form-group :label="msg('Fax')" label-for="realEstate-buy-price">
          <b-form-input
              id="realEstate-buy-price"
              v-model="realEstate.contactPerson.fax"
              @change="onValueUpdated"
          />
        </b-form-group>
      </b-col>

      <!-- Address -->
      <b-col cols="6">
        <b-form-group :label="msg('Address')" label-for="realEstate-buy-price">
          <b-form-input
              id="realEstate-buy-price"
              v-model="realEstate.contactPerson.address"
              @change="onValueUpdated"
          />
        </b-form-group>
      </b-col>

      <!-- Zip -->
      <b-col cols="3">
        <b-form-group :label="msg('Zip')" label-for="realEstate-buy-price">
          <b-form-input
              id="realEstate-buy-price"
              v-model="realEstate.contactPerson.zip"
              @change="onValueUpdated"
          />
        </b-form-group>
      </b-col>

      <!-- City -->
      <b-col cols="3">
        <b-form-group :label="msg('city')" label-for="realEstate-buy-price">
          <b-form-input
              id="realEstate-buy-price"
              v-model="realEstate.contactPerson.city"
              @change="onValueUpdated"
          />
        </b-form-group>
      </b-col>

      <!-- Logo URL -->
      <b-col cols="12">
        <b-form-group :label="msg('Logo url')" label-for="realEstate-buy-">
          <b-form-input
              id="realEstate-buy-"
              v-model="realEstate.contactPerson.imageUrl"
              @change="onValueUpdated"
          />
        </b-form-group>
      </b-col>
    </b-row>
      </div>
    </div>

    <div class="re-section re-section--info">
      <div class="re-section__head">
        <div class="re-section__icon"><feather-icon icon="CopyIcon" size="20"/></div>
        <div class="re-section__titles">
          <div class="re-section__title">{{ msg('Copy from another property') }}</div>
          <div class="re-section__sub">{{ msg('Copy contact data from an existing property') }}</div>
        </div>
      </div>
      <div class="re-section__body">
    <b-row class="mt-5" style="float: right">
      <!-- Add Property ID Input + Button -->
      <b-col cols="12" class="d-flex align-items-end">
        <b-form-group :label="msg('Property ID')" >
          <b-input-group>
            <b-form-input
                v-model="newPropertyId"
                placeholder="Enter Property ID"
            />
            <b-input-group-append>
              <b-button :disabled="newPropertyId==null" variant="warning" @click="copyAndUpdate">
                {{ msg('Copy data from this Property') }}
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>

    </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'realEstateContact',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      newPropertyId: null,
    }
  },
  computed: {
    ...mapGetters('realEstate', ['getAllTypes']),
    ...mapGetters('data', ['getAllBranches']),
    ...mapGetters('data', ['getAllCountries', 'getAllLanguage']),

    allBranches() {
      return Object.values(this.getAllBranches)
    },
    allCountries() {
      return Object.values(this.getAllCountries)
    },

    realEstate: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    ...mapActions ('realEstate', ['copyRealEstateContactPerson']),
    onEditorChange({ quill, html, text }) {
      if (this.realEstate.description === html) return
      this.realEstate.description = html
      this.onValueUpdated({ quill, html, text })
    },
    onValueUpdated(args) {
      this.$emit('change', args)
    },
    copyAndUpdate() {
      console.log( "copyRealEstateContactPerson: ", this.realEstate.id,this.newPropertyId)

      this.copyRealEstateContactPerson({
        id: this.realEstate.id,
        newPropertyId: this.newPropertyId
      })
        .then(() => {
          this.$emit('refresh', this.realEstate)
        })
        .catch(error => {
          console.error('Error copying contact person:', error)
        })
    }
  }
}
</script>

<style>
.realEstate-description .ql-editor {
  min-height: 200px;
}
</style>
